import * as React from 'react'

const defaultColor = '#9BA3B2'
const activeColor = '#3C52EF'

export default ({ isActive = false }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M21.9448 16.7764C21.9481 16.7764 21.9514 16.7761 21.9547 16.7761V17.2876C21.9514 17.2876 21.9481 17.2874 21.9448 17.2874C19.3645 17.2874 17.2727 19.3788 17.272 21.959L17.272 22H16.7728V21.959C16.7721 19.3788 14.6803 17.2874 12.0999 17.2874C12.0966 17.2874 12.0934 17.2876 12.09 17.2876C9.80847 17.2924 7.91201 18.9325 7.50785 21.098C4.23829 19.426 2 16.0244 2 12.1C2 6.52191 6.52189 2 12.0999 2C16.9904 2 21.0688 5.47588 22 10.0919H16.3184C15.5666 8.51812 13.9604 7.4307 12.0999 7.4307C9.51924 7.4307 7.4271 9.5228 7.4271 12.1035C7.4271 14.6809 9.51391 16.7707 12.09 16.7761C12.0934 16.7761 12.0966 16.7764 12.0999 16.7764C14.6803 16.7764 16.7721 14.6848 16.7728 12.1046V12.1041L17.272 12.1041V12.1048C17.2727 14.6849 19.3645 16.7764 21.9448 16.7764Z"
      fill={isActive ? activeColor : defaultColor}
    />
  </svg>
)
